module.exports = __webpack_public_path__ + "static/media/AvancesEnElProyectoDeRedCompartida.21ac3cef.pdf";